import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-77cb5f95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "driver" }, "~", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "driver" }, "~", -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suffix" }, "字节", -1))
const _hoisted_8 = {
  key: 4,
  class: "enum-box"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { class: "params-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "ws_drawer_footer" }

import { ref, computed, watch } from 'vue'
import { cloneDeep, isEmpty } from 'lodash'
import {
  CODE_ENUM,
  DATA_TYPE,
  ACCESS_MODE_TYPE,
  MODEL_TYPE,
  varReg,
} from '@/common'
import Parameter from './parameter-drawer.vue'
import { useModelStore } from '@/stores/model'
import { removeModelField } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'parameter-all-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const modelStore = useModelStore()

const props = __props
const $emit = __emit

const formRef = ref()

const dateOps = [
  {
    value: DATA_TYPE.INT,
    label: 'int32(整数型)',
  },
  {
    value: DATA_TYPE.DOUBLE,
    label: 'double(浮点型)',
  },
  {
    value: DATA_TYPE.STRING,
    label: 'string(字符形)',
  },
  {
    value: DATA_TYPE.ENUM,
    label: 'enum(枚举)',
  },
  {
    value: DATA_TYPE.DATE,
    label: 'date(时间戳)',
  },
  {
    value: DATA_TYPE.BOOL,
    label: 'bool(布尔形)',
  },
  {
    value: DATA_TYPE.STRUCT,
    label: 'struct(结构体)',
  },
]

const formData: any = ref({
  name: '',
  code: '',
  type: '',
  accessMode: ACCESS_MODE_TYPE.RO,
  desc: '',
  min: undefined,
  max: undefined,
  step: undefined,
  unit: '',
  falseValue: '',
  trueValue: '',
  maxLen: undefined,
  properties: [],
  range: [''],
  defaultVal: undefined,
})

watch(
  () => props.visible,
  () => {
    if (props.visible && !isEmpty(props.data)) {
      const { name, code, desc, accessMode, dataType } = props.data
      formData.value = {
        ...formData.value,
        name,
        code,
        desc,
        accessMode,
        ...dataType,
      }
    }
  }
)

const validatorCode = (rule: any, value: any, callback: any) => {
  if (varReg.test(value)) {
    callback()
  } else {
    callback('字母、下划线、数字组合，且数字不能开头')
  }
}

const validatorProperties = (rule: any, value: any, callback: any) => {
  const codeList = (value || []).map(({ code }: any) => {
    return code
  })
  if ([...new Set(codeList)].length !== (value || []).length) {
    callback('参数名不能相同')
  } else {
    callback()
  }
}

const validateMax = (rule: any, value: any, callback: any) => {
  if (value <= formData.value.min) {
    callback('最大值要大于最小值')
  } else {
    callback()
  }
}
const validateDefaultValue = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback()
  }
  if ([DATA_TYPE.INT, DATA_TYPE.DOUBLE].includes(formData.value.type)) {
    const { max, min } = formData.value
    if (typeof min === 'number' && min > value) {
      callback('默认值超出取值范围')
      return
    }
    if (typeof max === 'number' && max < value) {
      callback('默认值超出取值范围')
      return
    }
    callback()
  } else {
    callback()
  }
}
const rules: any = {
  name: [{ required: true, message: '请输入' }],
  code: [
    { required: true, message: '请输入' },
    {
      validator: validatorCode,
    },
  ],
  type: [{ required: true, message: '请选择' }],
  accessMode: [{ required: true, message: '请输入' }],
  falseValue: [{ required: true, message: '请输入' }],
  trueValue: [{ required: true, message: '请输入' }],
  maxLen: [{ required: true, message: '请输入' }],
  properties: [
    { required: true, message: '请选择', type: 'array' },
    {
      validator: validatorProperties,
    },
  ],
  max: [{ validator: validateMax }],
  defaultVal: [{ validator: validateDefaultValue }],
}
const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      const { name, code, desc, accessMode, ...p } = formData.value
      const unitName = modelStore.getUnitName(formData.value.unit)
      const dataType = removeModelField({ ...p, unitName })

      $emit('on-success', {
        name,
        code,
        desc,
        accessMode,
        dataType,
      })
      handleClose()
    }
  })
}

const handleClose = () => {
  $emit('update:visible', false)
  formData.value = {
    name: '',
    code: '',
    type: '',
    accessMode: ACCESS_MODE_TYPE.RO,
    desc: '',
    min: undefined,
    max: undefined,
    step: undefined,
    unit: '',
    falseValue: '',
    trueValue: '',
    maxLen: undefined,
    properties: [],
    range: [''],
    defaultVal: undefined,
  }
}

const reduceEnum = (index: number) => {
  formData.value.range = formData.value.range.filter(
    (item: any, i: number) => i !== index
  )
}

const addEnum = () => {
  formData.value.range.push('')
}

const removeParameter = (index: number) => {
  formData.value.properties = formData.value.properties.filter(
    (item: any, i: number) => i !== index
  )
}

const onParameterSuccess = (data: any) => {
  const { index } = parameterConf.value
  if (index === -1) {
    formData.value.properties.push(data)
  } else {
    formData.value.properties[index] = data
  }
  formRef.value.validateField('properties')
}

const parameterConf = ref({
  visible: false,
  data: {},
  index: -1,
})

const parameterForm = (data: any, index: number) => {
  parameterConf.value = {
    visible: true,
    data,
    index,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      "model-value": props.visible,
      "destroy-on-close": "",
      title: "创建参数",
      size: "480px",
      "before-close": handleClose,
      "label-position": "left"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: handleClose,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: rules,
          class: "form ws_common_form",
          "label-width": 90
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "功能名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  clearable: "",
                  maxlength: "50",
                  placeholder: "请输入功能名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "标识符",
              prop: "code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.code) = $event)),
                  clearable: "",
                  maxlength: "50",
                  placeholder: "请输入标识符"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "数据类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.type) = $event)),
                  class: "ws_select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (formData.value.type === _unref(DATA_TYPE).INT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_el_row, { getter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 13 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "取值范畴",
                            prop: "min"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                controls: false,
                                class: "ws_left",
                                precision: 0,
                                modelValue: formData.value.min,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.min) = $event)),
                                clearable: "",
                                maxlength: "50",
                                placeholder: "请输入最小值"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            "label-width": "1",
                            prop: "max"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: formData.value.max,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.max) = $event)),
                                controls: false,
                                class: "ws_left",
                                precision: 0,
                                clearable: "",
                                maxlength: "50",
                                placeholder: "请输入最大值"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "步长",
                    prop: "step"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: formData.value.step,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.step) = $event)),
                        controls: false,
                        class: "ws_left ws_select",
                        precision: 0,
                        min: 1,
                        clearable: "",
                        maxlength: "50",
                        placeholder: "请输入步长"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "单位",
                    prop: "unit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.unit,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.unit) = $event)),
                        filterable: "",
                        class: "ws_select"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelStore).unitList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.code,
                              value: item.code,
                              label: item.name + ' / ' + item.code
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).DOUBLE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_row, { getter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 13 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "取值范畴",
                            prop: "min"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: formData.value.min,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.min) = $event)),
                                controls: false,
                                class: "ws_left",
                                precision: 2,
                                clearable: "",
                                maxlength: "50",
                                placeholder: "请输入最小值"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            "label-width": "1",
                            prop: "max"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                controls: false,
                                class: "ws_left",
                                precision: 2,
                                modelValue: formData.value.max,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.max) = $event)),
                                clearable: "",
                                placeholder: "请输入最大值"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "步长",
                    prop: "step"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        min: 0.01,
                        controls: false,
                        class: "ws_left ws_select",
                        precision: 2,
                        modelValue: formData.value.step,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.step) = $event)),
                        clearable: "",
                        maxlength: "50",
                        placeholder: "请输入步长"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "单位",
                    prop: "unit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.unit,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.unit) = $event)),
                        filterable: "",
                        class: "ws_select"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelStore).unitList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.code,
                              value: item.code,
                              label: item.name + ' / ' + item.code
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).BOOL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    label: "0-",
                    prop: "falseValue"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.falseValue,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.falseValue) = $event)),
                        clearable: "",
                        maxlength: "50",
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "1-",
                    prop: "trueValue"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.trueValue,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.trueValue) = $event)),
                        clearable: "",
                        maxlength: "50",
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).STRING)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: "数据长度",
                    prop: "maxLen",
                    class: "maxlenth-form"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        min: 1,
                        controls: false,
                        class: "ws_left ws_select",
                        precision: 0,
                        modelValue: formData.value.maxLen,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.maxLen) = $event)),
                        clearable: "",
                        maxlength: "50",
                        placeholder: "请输入步长"
                      }, null, 8, ["modelValue"]),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).ENUM)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.range, (enumItem, index) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      label: " ",
                      prop: 'range.' + index,
                      key: index,
                      rules: { required: true, message: '请输入' },
                      "hide-required-asterisk": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.range[index],
                          "onUpdate:modelValue": ($event: any) => ((formData.value.range[index]) = $event),
                          clearable: "",
                          maxlength: "50",
                          placeholder: "请输入成员",
                          style: {"width":"310px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", {
                          class: "icon-reduce ws_ml15",
                          onClick: ($event: any) => (reduceEnum(index))
                        }, [
                          _createVNode(_component_el_icon, {
                            size: "18",
                            color: "#409EFF"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_9), [
                          [_vShow, index !== 0]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  }), 128)),
                  _createVNode(_component_el_button, {
                    onClick: addEnum,
                    type: "text",
                    style: {"margin-left":"90px"},
                    class: "ws_mb20"
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 增加成员 ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).STRUCT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, {
                    label: "JSON对象",
                    prop: "properties"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.properties, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "params-item",
                            key: index
                          }, [
                            _createElementVNode("span", null, "参数名：" + _toDisplayString(item.code), 1),
                            _createElementVNode("span", null, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (parameterForm(item, index))
                              }, "编辑", 8, _hoisted_13),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (removeParameter(index))
                              }, "删除", 8, _hoisted_14)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode(_component_el_button, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (parameterForm({}, -1))),
                        type: "text"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_15
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" 增加参数 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).STRING)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 6,
                  label: "默认值",
                  prop: "defaultVal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.defaultVal,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.defaultVal) = $event)),
                      clearable: "",
                      maxlength: "50",
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).INT)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 7,
                  label: "默认值",
                  prop: "defaultVal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      class: "ws_left ws_select",
                      precision: 0,
                      modelValue: formData.value.defaultVal,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.defaultVal) = $event)),
                      clearable: "",
                      maxlength: "50",
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).DOUBLE)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 8,
                  label: "默认值",
                  prop: "defaultVal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      class: "ws_left ws_select",
                      precision: 2,
                      modelValue: formData.value.defaultVal,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.defaultVal) = $event)),
                      clearable: "",
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formData.value.type === _unref(DATA_TYPE).DATE)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 9,
                  label: "默认值",
                  prop: "defaultVal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.defaultVal,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.defaultVal) = $event)),
                      clearable: "",
                      maxlength: "50",
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "读写类型",
              prop: "accessMode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.accessMode,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.accessMode) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: _unref(ACCESS_MODE_TYPE).RO
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("只读")
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(ACCESS_MODE_TYPE).WR
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("只写")
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(ACCESS_MODE_TYPE).RW
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("读写")
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "desc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.desc,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.desc) = $event)),
                  type: "textarea",
                  rows: 3,
                  maxlength: "50",
                  placeholder: "请输入备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(Parameter, {
      visible: parameterConf.value.visible,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((parameterConf.value.visible) = $event)),
      data: parameterConf.value.data,
      onOnSuccess: onParameterSuccess
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})